module.exports = __webpack_public_path__ + "static/media/sf-test-4.6a39a7e8.mp3";